import React from 'react'
import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb'
import classes from './Help.module.scss'
import Accordion from './component/Accordion'
import infos from './Infos'

const Help = () => {
    return (
        <>
            <BreadCrumb name="Help" />
            <div className={classes.Help}>
                {infos.map((item) => {
                    return <div key={item.id}><Accordion heading={item.heading} title={item.title} content={item.content} /> </div>
                })}
                
            </div>
        </>
    )
}

export default Help


